import { SpaceProps } from '@app/types'

import { StyledSpace } from './elements'

export const Space: React.FC<SpaceProps> = (props) => <StyledSpace {...props} />
